module.exports = __webpack_public_path__ + "static/media/cses-part-02.f28d255c.md";